import React from 'react';
import { useLocation } from 'react-router';

import LoggedoutView from '@xingternal/xing-view/LoggedoutView'; // eslint-disable-line
import { Grid } from '@xingternal/xing-grid';
import { useConfig } from '@xingternal/hops';

import styles from './LoggedOutApp.css';

type LoggedOutAppProps = {
  children: React.ReactNode;
};

const LoggedOutApp = ({ children }: LoggedOutAppProps) => {
  const { pathname = '', search = '', hash = '' } = useLocation();
  const { externalLoginUrl } = useConfig();

  const loginLink = `${externalLoginUrl}/?dest_url=${pathname}${search}${hash}`;

  return (
    <LoggedoutView
      withSubNav
      gridClassName={styles.gridClassName}
      loginLink={loginLink}
      // signup link redirects to login like all other apps (for consistency)
      signupLink={loginLink}
    >
      <Grid>{children}</Grid>
    </LoggedoutView>
  );
};

export default LoggedOutApp;
